module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "vue-header",
    on: {
      "touchmove": _vm.onShortcutTouchStart
    }
  }, [_c('div', {
    staticClass: "header-left ",
    on: {
      "click": _vm.goback
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header-center "
  }, [_vm._v(_vm._s(_vm.headerTitle))]), _vm._v(" "), _c('div', {
    staticClass: "header-right"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rightContentPropsMain),
      expression: "rightContentPropsMain"
    }]
  }, [(_vm.rightContentProps) ? _c('img', {
    staticClass: "right-connectUs",
    attrs: {
      "src": require("./img/server_person.png"),
      "onclick": "_MEIQIA('showPanel', {agentToken: '客服智子的 Token'})"
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "hmore",
    on: {
      "click": _vm.more
    }
  }, [_vm._v("更多")]), _vm._v(" "), _c('span', {
    staticClass: "hmore",
    on: {
      "click": _vm.more
    }
  }, [_vm._v("更多")])])]), _vm._v(" "), (_vm.servers) ? _c('div', {
    staticClass: "more_show",
    on: {
      "click": _vm.customer
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.servers) ? _c('div', {
    staticClass: "more_show",
    on: {
      "click": _vm.customer
    }
  }) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e6a7adb4"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/header/header.vue
// module id = 425
// module chunks = 1